export default __webpack_public_path__ + "tmp_node_modules/country-flag-icons/3x2/flags.css.liquid";